// src/config/rolePermissions.js
// Rol bazlı modül erişim izinleri

/**
 * Varsayılan modül listesi
 * Her modül bir key ve label içerir
 */
export const MODULES = {
    dashboard: { key: 'dashboard', label: 'Panel', path: '/' },
    customers: { key: 'customers', label: 'Müşteriler', path: '/musteriler' },
    devices: { key: 'devices', label: 'Cihazlar', path: '/cihazlar' },
    serviceBoard: { key: 'serviceBoard', label: 'Servis Panosu', path: '/servis-panosu' },
    serviceRecords: { key: 'serviceRecords', label: 'Servis Kayıtları', path: '/servis-kayitlari' },
    createService: { key: 'createService', label: 'Servis Kaydı Oluştur', path: '/servis-kaydi-olustur' },
    sales: { key: 'sales', label: 'Satışlar', path: '/satislar' },
    createSale: { key: 'createSale', label: 'Satış Oluştur', path: '/satis-olustur' },
    appointments: { key: 'appointments', label: 'Randevular', path: '/randevular' },
    calendar: { key: 'calendar', label: 'Takvim', path: '/takvim' },
    materials: { key: 'materials', label: 'Malzemeler', path: '/malzemeler' },
    stocks: { key: 'stocks', label: 'Stok Yönetimi', path: '/stok-yonetimi' },
    account: { key: 'account', label: 'Cari Hesaplar', path: '/cari-hesaplar' },
    reports: { key: 'reports', label: 'Raporlar', path: '/raporlar' },
    maintenance: { key: 'maintenance', label: 'Bakım Takip', path: '/bakim-takip' },
    sleepTracking: { key: 'sleepTracking', label: 'Uyku Takip', path: '/uyku-takip' },
    sgkDevices: { key: 'sgkDevices', label: 'SGK Cihaz Listesi', path: '/sgk-cihaz-listesi' },
    settings: { key: 'settings', label: 'Ayarlar', path: '/ayarlar' },
    userManagement: { key: 'userManagement', label: 'Kullanıcı Yönetimi', path: '/kullanici-yonetimi' },
};

/**
 * Varsayılan rol izinleri
 * true = erişim var, false = erişim yok
 */
export const DEFAULT_ROLE_PERMISSIONS = {
    'Yönetici': {
        // Yönetici tüm modüllere erişebilir
        dashboard: true,
        customers: true,
        devices: true,
        serviceBoard: true,
        serviceRecords: true,
        createService: true,
        sales: true,
        createSale: true,
        appointments: true,
        calendar: true,
        materials: true,
        stocks: true,
        account: true,
        reports: true,
        maintenance: true,
        sleepTracking: true,
        sgkDevices: true,
        settings: true,
        userManagement: true,
    },
    'Servis Teknisyeni': {
        // Servis teknisyeni: Sadece servis kayıtlarıyla ilgili alanları görür
        // Finansal bilgiler, müşteri bilgileri, stok, cari hesaplar, raporlar erişim yok
        dashboard: true,
        customers: false,         // Müşteri bilgilerine erişim yok
        devices: true,
        serviceBoard: true,
        serviceRecords: true,
        createService: true,
        sales: false,             // Satışlara erişim yok
        createSale: false,        // Satış oluşturma yok
        appointments: true,
        calendar: true,
        materials: true,
        stocks: false,            // Stok yönetimi yok
        account: false,           // Cari hesaplar yok
        reports: false,           // Raporlar yok
        maintenance: true,
        sleepTracking: true,
        sgkDevices: true,
        settings: false,          // Ayarlar yok
        userManagement: false,    // Kullanıcı yönetimi yok
    },
    'Ofis Personeli': {
        // Ofis personeli: Yönetici ile aynı yetkilere sahip (kullanıcı yönetimi hariç)
        dashboard: true,
        customers: true,
        devices: true,
        serviceBoard: true,
        serviceRecords: true,
        createService: true,
        sales: true,
        createSale: true,
        appointments: true,
        calendar: true,
        materials: true,
        stocks: true,
        account: true,            // Cari hesaplar erişim var
        reports: true,
        maintenance: true,
        sleepTracking: true,
        sgkDevices: true,
        settings: false,          // Ayarlar yok
        userManagement: false,    // Kullanıcı yönetimi yok
    },
};

/**
 * Rol listesi
 */
export const ROLES = ['Yönetici', 'Servis Teknisyeni', 'Ofis Personeli'];

/**
 * Belirli bir rol için modül erişimi kontrolü
 * @param {string} role - Kullanıcı rolü
 * @param {string} moduleKey - Modül anahtarı
 * @param {object} customPermissions - Özelleştirilmiş izinler (Firestore'dan)
 * @returns {boolean} - Erişim izni var mı
 */
export const hasModuleAccess = (role, moduleKey, customPermissions = null) => {
    // Eğer özelleştirilmiş izinler varsa önce onlara bak
    if (customPermissions && customPermissions[moduleKey] !== undefined) {
        return customPermissions[moduleKey];
    }

    // Varsayılan izinlere bak
    const rolePermissions = DEFAULT_ROLE_PERMISSIONS[role];
    if (!rolePermissions) {
        // Bilinmeyen rol - güvenlik için erişimi reddet
        return false;
    }

    return rolePermissions[moduleKey] === true;
};

/**
 * Belirli bir rol için erişilebilir modülleri getir
 * @param {string} role - Kullanıcı rolü
 * @param {object} customPermissions - Özelleştirilmiş izinler
 * @returns {array} - Erişilebilir modül listesi
 */
export const getAccessibleModules = (role, customPermissions = null) => {
    return Object.keys(MODULES).filter(moduleKey =>
        hasModuleAccess(role, moduleKey, customPermissions)
    );
};
